import { render, staticRenderFns } from "./florist-review-create.vue?vue&type=template&id=d3894f1e"
import script from "./florist-review-create.vue?vue&type=script&lang=js"
export * from "./florist-review-create.vue?vue&type=script&lang=js"
import style0 from "./florist-review-create.vue?vue&type=style&index=0&id=d3894f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports